<template>
  <div>
    <TitleWithButton
      :title="pageTitle"
      :skeleton="isLoadingAsyncData"
      :button-text="Model.page_title.create"
      :creatable="creatable"
      class="mt-6 mb-4 headline"
      @create="onActionCreate"
    />

    <BTableCommon
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading || isLoadingAsyncData"
      sortable-positions
      type="base-events"

      @change:sort="onChangeSort"
      @change:pagination="onChangePagination"
      @change:sortable-positions="onUpdatePositions"

      @action:edit="onActionEdit"
      @action:view="onActionView"
      @action:delete="onActionDelete"
    />
  </div>
</template>

<script>
import { lkRoadmapPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { RoadmapBaseEventModel as Model } from './Model'
import { roadmapBaseEventsStoreModule as StoreModule } from './store'
import { createRoadmapBaseEventsModal } from './utils'

import BTableCommon from '@/components/tables/BTableCommon.vue'
import TitleWithButton from '@/components/common/TitleWithButton.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewRoadmapBaseEventsList',
  components: {
    BTableCommon,
    TitleWithButton,
  },
  mixins: [
    listMixin,
  ],
  props: {
    roadmapId: {
      type: [Number, String],
      required: true,
    },
    directionId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      disabledPaginationQuery: true,
      defaultParams: {
        roadmap_id: this.roadmapId,
        direction_id: this.directionId,
      },
    }
  },
  computed: {
    creatable() {
      return this.$access(Permissions.create)
    },
  },
  /** @type { List } */
  methods: {
    onActionCreate() {
      const readonly = false
      this.onOpenModal(null, readonly)
    },
    onActionEdit(data, callback) {
      const readonly = false
      this.onOpenModal(data, readonly, callback)
    },
    onActionView(data, callback) {
      const readonly = true
      this.onOpenModal(data, readonly, callback)
    },
    async onActionDelete(data) {
      await this.onOpenModal(data, this.defaultParams)
    },
    async onOpenModal(data, readonly, callback) {
      const propsData = await this.getPropsData(data, readonly, callback)
      const modal = await createRoadmapBaseEventsModal(this, propsData)
      await modal.open()
      this.onGetData(this.filters)
    },
    async getPropsData(dataParams, readonly = false, callback) {
      let data

      if (dataParams) {
        const options = {
          ...this.defaultParams,
          payload: { ...dataParams, ...this.defaultParams },
          id: dataParams.id,
        }

        const unwatch = callback?.()
        data = await this.getOne(options).catch(() => dataParams)
        unwatch?.()
      }

      const action = (payload) => {
        const options = {
          ...this.defaultParams,
          payload: { ...payload, ...this.defaultParams },
          id: payload.id,
        }

        const promise = payload.id
          ? this.update(options)
          : this.create(options)

        return promise
      }

      const propsData = {
        data,
        readonly,
        actionSave: action,
        actionDelete: this.onActionDelete,
        successText: data ? Model.response_success.update : Model.response_success.create,
        errorText: data ? Model.response_error.update : Model.response_error.create,
        ...this.defaultParams,
      }

      return propsData
    },
  },
}
</script>
